import { EarnReward, FriendSignUp, ReferShareIcon } from "assets/icons";

export const steps = [
  { icon: ReferShareIcon, label: "Share your referral link" },
  { icon: FriendSignUp, label: "Friend signs up" },
  { icon: EarnReward, label: "Earn rewards" },
];

export const ticketData = [
  {
    key: 1,
    offer: "20% OFF",
    title: "Exclusive match boost",
    code: "BDJ232NE",
    valid: "12 Nov 2024",
    bg: "#36D9CB",
    text: "#039387",
  },
  {
    key: 2,
    offer: "15+ VIEWS",
    title: "More contact unlock",
    code: "BDJ232NE",
    valid: "12 Nov 2024",
    bg: "#9C9CF4",
    text: "#5D5DAB",
  },
];
